var map = {
	"./icon-arrow-up.svg": 19,
	"./icon-close.svg": 20,
	"./icon-email.svg": 21,
	"./icon-facebook.svg": 22,
	"./icon-instagram.svg": 23,
	"./icon-linkedin.svg": 24,
	"./icon-menu.svg": 25,
	"./icon-phone.svg": 26,
	"./icon-twitter.svg": 27,
	"./icon-vimeo.svg": 28,
	"./logo-mark.svg": 29,
	"./logo-overlay.svg": 30
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18;